module.exports = __webpack_public_path__ + "static/4-a4aeb9ec478c297b915829acacddadcf.png";